import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { EmptyListIcon } from '@systemeio/ui/icons'

const EmptyFunnelStepList = () => {
  const { t } = useLocoTranslation()
  return (
    <div
      className={`gap-3py-20 bg-background-secondary flex w-full flex-col items-center justify-center rounded-lg pb-10`}
    >
      <EmptyListIcon />
      <div className={`flex flex-col items-center`}>
        <span className={'text-text-primary text-base'}>
          {t('dashboard.funnel.configuration.common.list.empty_title.first_line')}
        </span>
        <span className={'text-text-primary text-base'}>
          {t('dashboard.funnel.configuration.common.list.empty_title.list.empty_list')}
        </span>
      </div>
    </div>
  )
}

export default EmptyFunnelStepList
